import { StandardEvents } from '@shopify/events';
import { morph } from '@theme/morph';

/**
 * Keeps the Console + Drawer Set's offer and contents in step with the console tray
 * chosen on the set page. Choosing an option re-renders the product section, and this
 * swaps in the block's markup from that render, the way product-inventory.js does.
 */
class TraySetBlock extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /** @param {Event & { promise?: Promise<{ detail?: { html?: Document } }> }} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;

    event.promise
      .then(({ detail } = {}) => {
        const next = detail?.html?.querySelector(`cg-tray-set-block[data-block-id="${this.dataset.blockId}"]`);
        if (next) morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[cg-tray-set] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('cg-tray-set-block')) {
  customElements.define('cg-tray-set-block', TraySetBlock);
}
